import React, { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function PaymentReturn() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [status, setStatus] = useState("checking");
  const polls = useRef(0);

  useEffect(() => {
    const sessionId = params.get("session_id");
    if (!sessionId) { setStatus("error"); return; }

    const poll = async () => {
      if (polls.current >= 6) { setStatus("timeout"); return; }
      polls.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("success");
          await checkAuth();
          return;
        }
        if (data.status === "expired") { setStatus("error"); return; }
        setTimeout(poll, 2000);
      } catch { setStatus("error"); }
    };
    poll();
  }, [params, checkAuth]);

  const content = {
    checking: { icon: <Loader2 size={48} className="text-blue-500 animate-spin" />, title: "Verifica pagamento...", desc: "Attendere qualche istante." },
    success: { icon: <CheckCircle2 size={48} className="text-emerald-500" />, title: "Pagamento completato!", desc: "Il tuo abbonamento Premium è attivo. Ora hai accesso a tutti i segnali." },
    timeout: { icon: <Loader2 size={48} className="text-amber-500" />, title: "Verifica in corso", desc: "Il pagamento è in elaborazione. Controlla la dashboard tra poco." },
    error: { icon: <XCircle size={48} className="text-red-500" />, title: "Pagamento non riuscito", desc: "Si è verificato un problema. Riprova." },
  }[status];

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6">
      <div data-testid="payment-return" className="bg-[#141414] border border-white/10 rounded-md p-10 max-w-md w-full text-center animate-in-up">
        <div className="flex justify-center mb-6">{content.icon}</div>
        <h1 className="text-2xl font-bold tracking-tight mb-2">{content.title}</h1>
        <p className="text-zinc-400 mb-8">{content.desc}</p>
        <div className="flex gap-3 justify-center">
          <Link to="/dashboard" data-testid="payment-dashboard-btn" className="px-5 py-2.5 rounded-md bg-white text-black font-medium hover:bg-zinc-200 transition-colors">Vai alla Dashboard</Link>
          {status === "error" && <Link to="/pricing" className="px-5 py-2.5 rounded-md border border-white/20 font-medium hover:bg-white/5 transition-colors">Riprova</Link>}
        </div>
      </div>
    </div>
  );
}
